export function FacebookIcon() {
  return (
    <svg
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="24.7283"
        cy="24.7283"
        r="24.0217"
        fill="white"
        stroke="#ADADAD"
        strokeWidth="1.41304"
      />
      <path
        d="M29.3825 16.1716H31.9168V11.8848C30.6897 11.7572 29.4568 11.6942 28.2231 11.6961C24.5565 11.6961 22.0491 13.9338 22.0491 18.0319V21.5637H17.9106V26.3628H22.0491V38.6569H27.0099V26.3628H31.1349L31.755 21.5637H27.0099V18.5037C27.0099 17.0882 27.3874 16.1716 29.3825 16.1716Z"
        fill="black"
      />
    </svg>
  );
}

export function InstagramIcon() {
  return (
    <svg width="50" height="50" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle
        cx="24.728"
        cy="24.728"
        r="24.022"
        fill="#fff"
        stroke="#ADADAD"
        strokeWidth="1.413"
      />
      <path
        d="M32.192 16.103a1.6 1.6 0 1 0 0 3.2 1.6 1.6 0 0 0 0-3.2Zm6.134 3.227a10.12 10.12 0 0 0-.614-3.24 6.586 6.586 0 0 0-1.546-2.36 6.268 6.268 0 0 0-2.36-1.533 9.735 9.735 0 0 0-3.24-.627c-1.414-.08-1.867-.08-5.494-.08-3.626 0-4.08 0-5.493.08a9.735 9.735 0 0 0-3.24.627 6.374 6.374 0 0 0-2.36 1.533 6.267 6.267 0 0 0-1.533 2.36 9.735 9.735 0 0 0-.627 3.24c-.08 1.413-.08 1.867-.08 5.493 0 3.627 0 4.08.08 5.494a9.735 9.735 0 0 0 .627 3.24c.325.892.85 1.7 1.533 2.36a6.372 6.372 0 0 0 2.36 1.533 9.735 9.735 0 0 0 3.24.627c1.413.08 1.867.08 5.493.08 3.627 0 4.08 0 5.494-.08a9.735 9.735 0 0 0 3.24-.627c.892-.326 1.7-.85 2.36-1.533a6.466 6.466 0 0 0 1.546-2.36c.38-1.04.588-2.134.614-3.24 0-1.414.08-1.867.08-5.494 0-3.626 0-4.08-.08-5.493Zm-2.4 10.827a7.478 7.478 0 0 1-.454 2.48 4.078 4.078 0 0 1-1 1.533c-.432.44-.955.782-1.533 1a7.478 7.478 0 0 1-2.48.453c-1.333.067-1.827.08-5.333.08-3.507 0-4 0-5.334-.08a7.642 7.642 0 0 1-2.586-.4 4.363 4.363 0 0 1-1.467-1 4.002 4.002 0 0 1-.987-1.533 7.387 7.387 0 0 1-.533-2.533c0-1.334-.08-1.827-.08-5.334 0-3.506 0-4 .08-5.333a7.386 7.386 0 0 1 .467-2.533 4 4 0 0 1 1.053-1.467 4.186 4.186 0 0 1 1.467-1.067 7.64 7.64 0 0 1 2.533-.453c1.333 0 1.827-.08 5.333-.08 3.507 0 4 0 5.334.08.846.01 1.685.163 2.48.453.606.225 1.15.59 1.586 1.067.437.41.779.91 1 1.467.297.811.45 1.669.454 2.533.066 1.333.08 1.827.08 5.333 0 3.507-.014 4-.08 5.334ZM25.072 17.983a6.84 6.84 0 1 0 6.854 6.84 6.827 6.827 0 0 0-6.854-6.84Zm0 11.28a4.44 4.44 0 1 1 0-8.88 4.44 4.44 0 0 1 0 8.88Z"
        fill="#000"
      />
    </svg>
  );
}
export function CheckMarkIcon({ fill }) {
  return (
    <svg
      width="15"
      height="12"
      viewBox="0 0 15 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 1L4 11.01L1 8.01"
        stroke={fill}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function CheckIcon() {
  return (
    <svg
      width="800px"
      height="800px"
      viewBox="0 0 48 48"
      version="1"
      xmlns="http://www.w3.org/2000/svg"
      enableBackground="new 0 0 48 48"
    >
      <polygon
        fill="#43A047"
        points="40.6,12.1 17,35.7 7.4,26.1 4.6,29 17,41.3 43.4,14.9"
      />
    </svg>
  );
}

export function LoaderVectors() {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.0744 22.2495C18.8565 24.2716 15.9829 25.4245 12.9825 25.496C6.08096 25.6702 0.345287 20.217 0.171084 13.3154C0.103712 10.6463 0.878491 8.15092 2.25181 6.08561L6.41909 13.1577L2.67028 13.2523C2.71959 15.2122 3.34389 17.1143 4.46555 18.7222C5.58721 20.3301 7.15675 21.5728 8.97901 22.2959C10.8013 23.0189 12.7959 23.1904 14.7148 22.7889C16.6337 22.3875 18.3923 21.4308 19.7719 20.038L21.0744 22.2495ZM4.25978 3.75046C6.47766 1.72842 9.35126 0.575535 12.3517 0.503991C19.2532 0.329788 24.9889 5.78304 25.1631 12.6846C25.2305 15.3537 24.4557 17.8491 23.0824 19.9144L18.9151 12.8423L22.6639 12.7477C22.6146 10.7878 21.9903 8.88569 20.8686 7.2778C19.747 5.66991 18.1774 4.42718 16.3552 3.70414C14.5329 2.9811 12.5383 2.80964 10.6194 3.21108C8.70046 3.61253 6.94185 4.56916 5.56225 5.96204L4.25978 3.75046Z"
        fill="white"
      />
    </svg>
  );
}
